import './app.cookieconsent';
import './app.cookieconsent.init';


/**
 * One-tune functions to do things to the DOM, etc
 */
export const initGlobalDOM = () => {

	// Cache
	var $window = $(window);
	var $body 	= $('body');
	var $header	= $('header');
	var $main 	= $('main');

	// Remove .no-js
	$('html').removeClass('no-js');
	
	// Determine input type
	var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
	$body.attr('data-input', isTouchDevice ? 'touch' : 'indirect');

	// Header scroll
	let lastScrollTop = 0;

	$window.on('scroll', function() {

		const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

		if (currentScroll > lastScrollTop && currentScroll > 0) {

			$body.addClass('scrolling-down').removeClass('scrolling-up');

		} else if (currentScroll < lastScrollTop) {

			$body.addClass('scrolling-up').removeClass('scrolling-down');

		}

		lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;

	});

	// Menu highlight
	$header.find('a[href="' + CSS.escape(window.location.pathname) + '"]').addClass('active');

	// Menu highlights for templates that aren't in the menu
	if ($main.data('parent-url') !== undefined) {

		var url = $main.data('parent-url');

		$header.find(`a[href="${CSS.escape(url)}"]`)
		       .addClass('active');

	}

	// Triggers
	window.dispatchEvent(new Event('scroll'));
	window.dispatchEvent(new Event('resize'));

};